import { Typography } from '@mui/material';
import usePagination from '@mui/material/usePagination';
import { clsx } from 'clsx';
import React, { memo } from 'react';

import chevronLeft from '~/assets/icons/chevron-left.svg';
import chevronRight from '~/assets/icons/chevron-right.svg';

import styles from './styles.module.scss';

interface Props {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const Component: React.FC<Props> = ({ currentPage, totalPages, onChange }) => {
  const { items } = usePagination({
    page: currentPage,
    count: totalPages,
    siblingCount: 2,
    onChange: (event, page) => onChange(page),
  });

  return (
    <div className={styles.pagination}>
      {items.map((item, index) => {
        if (item.type === 'previous') {
          return (
            <button
              aria-label="Previous"
              className={clsx(styles.pagination__button, styles['pagination__button--previous'])}
              disabled={item.disabled}
              key={index}
              type="button"
              onClick={item.onClick}
            >
              <img alt="chevron" src={chevronLeft} />
            </button>
          );
        }

        if (item.type === 'next') {
          return (
            <button
              aria-label="Next"
              className={clsx(styles.pagination__button, styles['pagination__button--next'])}
              disabled={item.disabled}
              key={index}
              type="button"
              onClick={item.onClick}
            >
              <img alt="chevron" src={chevronRight} />
            </button>
          );
        }

        if (item.type === 'start-ellipsis' || item.type === 'end-ellipsis') {
          return (
            <button
              disabled
              aria-label="Ellipsis"
              className={styles.pagination__button}
              key={index}
              type="button"
              onClick={item.onClick}
            >
              ...
            </button>
          );
        }

        return (
          <button
            className={clsx(styles.pagination__button)}
            disabled={item.disabled}
            key={index}
            type="button"
            onClick={item.onClick}
          >
            {item.selected ? (
              <div className={styles['pagination__button__active-container']}>
                <Typography color="var(--main-1-color)" fontWeight="700" variant="subtitle2">
                  {item.page}
                </Typography>
              </div>
            ) : (
              <Typography color="var(--gray-12-color)" fontWeight="700" variant="body1">
                {item.page}
              </Typography>
            )}
          </button>
        );
      })}
    </div>
  );
};

export const Pagination = memo(Component);
